// removed by extract-text-webpack-plugin
module.exports = {"menuLabelDesktop":"LocalizationMenu__menuLabelDesktop__2NyRh","localizationLink":"LocalizationMenu__localizationLink__Nn4Ir","menuItemBorder":"LocalizationMenu__menuItemBorder__23eOm","currentLocalizationFlag":"LocalizationMenu__currentLocalizationFlag__19FRA","localizationFlag":"LocalizationMenu__localizationFlag__3cUXp","localizationInfo":"LocalizationMenu__localizationInfo__2M720","countryText":"LocalizationMenu__countryText__aLV1I","menuIsOpen":"LocalizationMenu__menuIsOpen__yNYRW","menuContent":"LocalizationMenu__menuContent__308aw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LocalizationMenu/LocalizationMenu.css
// module id = 2188
// module chunks = 0